<template>  
  <Card
    class="koc-default-collection-item-webcast"
    :image-link="FormattingService.formatUrl(item)"
    :image-url="state.imageUrl"
    :content-title="item.title"
    :content-link="FormattingService.formatUrl(item)" 
  >
    <template #footer>
      <div class="koc-default-collection-item-webcast-footer">
        <div class="koc-default-collection-item-webcast-footer-link koc-title koc-montserrat">
          <a :href="FormattingService.formatUrl(item)">
            VIEW WEBCAST
          </a>
        </div>
        <div class="koc-default-collection-item-toolkit-footer-icon">
          <tooltip 
            text="More Information"
            :last="true"
          >
            <button
              class="koc-button koc-ripple koc-clear koc-small koc-text"
              @click="toggleModal(item)"
            >
              <font-awesome-icon
                :icon="['fa', 'info']"
              />
            </button>
          </tooltip>                  
        </div>
      </div>
    </template>  
  </Card>
</template>

<script src="./webcast.js"></script>
<style lang="scss" scoped src="./webcast.scss"></style>